// @ts-nocheck: converted from JS

import CreateAccount from '@/components/CreateAccount';

export default CreateAccount;
